export default "__VITE_ASSET__BaR_j9LQ__"